'use client';

import { c as _c } from "react/compiler-runtime";
import { motion } from 'framer-motion';
import { useTranslations } from 'next-intl';
import { cn } from '@/lib/utils';
import IconCode from '@/public/images/creator-intro/choose-code.svg';
import IconFilter from '@/public/images/creator-intro/choose-filter.svg';
import IconJump from '@/public/images/creator-intro/choose-jump.svg';
import IconPhone from '@/public/images/creator-intro/choose-phone.svg';
import IconRobot from '@/public/images/creator-intro/choose-robot.svg';
import IconServer from '@/public/images/creator-intro/choose-server.svg';
import IconSmile from '@/public/images/creator-intro/choose-smile.svg';
import IconStars from '@/public/images/creator-intro/choose-stars.svg';
import IconViverse from '@/public/images/creator-intro/choose-viverse.svg';
const useReasons = () => {
  const $ = _c(82);
  const t = useTranslations();
  let t0;
  if ($[0] !== t) {
    t0 = t("creator-intro.choose.reason-1-title");
    $[0] = t;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  let t1;
  if ($[2] !== t) {
    t1 = t("creator-intro.choose.reason-1-description");
    $[2] = t;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  let t2;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <IconSmile />;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] !== t0 || $[6] !== t1) {
    t3 = {
      title: t0,
      description: t1,
      icon: t2
    };
    $[5] = t0;
    $[6] = t1;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  let t4;
  if ($[8] !== t) {
    t4 = t("creator-intro.choose.reason-2-title");
    $[8] = t;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  let t5;
  if ($[10] !== t) {
    t5 = t("creator-intro.choose.reason-2-description");
    $[10] = t;
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  let t6;
  if ($[12] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <IconPhone />;
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  let t7;
  if ($[13] !== t4 || $[14] !== t5) {
    t7 = {
      title: t4,
      description: t5,
      icon: t6
    };
    $[13] = t4;
    $[14] = t5;
    $[15] = t7;
  } else {
    t7 = $[15];
  }
  let t8;
  if ($[16] !== t) {
    t8 = t("creator-intro.choose.reason-3-title");
    $[16] = t;
    $[17] = t8;
  } else {
    t8 = $[17];
  }
  let t9;
  if ($[18] !== t) {
    t9 = t("creator-intro.choose.reason-3-description");
    $[18] = t;
    $[19] = t9;
  } else {
    t9 = $[19];
  }
  let t10;
  if ($[20] === Symbol.for("react.memo_cache_sentinel")) {
    t10 = <IconJump />;
    $[20] = t10;
  } else {
    t10 = $[20];
  }
  let t11;
  if ($[21] !== t8 || $[22] !== t9) {
    t11 = {
      title: t8,
      description: t9,
      icon: t10
    };
    $[21] = t8;
    $[22] = t9;
    $[23] = t11;
  } else {
    t11 = $[23];
  }
  let t12;
  if ($[24] !== t) {
    t12 = t("creator-intro.choose.reason-4-title");
    $[24] = t;
    $[25] = t12;
  } else {
    t12 = $[25];
  }
  let t13;
  if ($[26] !== t) {
    t13 = t("creator-intro.choose.reason-4-description");
    $[26] = t;
    $[27] = t13;
  } else {
    t13 = $[27];
  }
  let t14;
  if ($[28] === Symbol.for("react.memo_cache_sentinel")) {
    t14 = <IconFilter />;
    $[28] = t14;
  } else {
    t14 = $[28];
  }
  let t15;
  if ($[29] !== t12 || $[30] !== t13) {
    t15 = {
      title: t12,
      description: t13,
      icon: t14
    };
    $[29] = t12;
    $[30] = t13;
    $[31] = t15;
  } else {
    t15 = $[31];
  }
  let t16;
  if ($[32] !== t) {
    t16 = t("creator-intro.choose.reason-5-title");
    $[32] = t;
    $[33] = t16;
  } else {
    t16 = $[33];
  }
  let t17;
  if ($[34] !== t) {
    t17 = t("creator-intro.choose.reason-5-description");
    $[34] = t;
    $[35] = t17;
  } else {
    t17 = $[35];
  }
  let t18;
  if ($[36] === Symbol.for("react.memo_cache_sentinel")) {
    t18 = <IconViverse />;
    $[36] = t18;
  } else {
    t18 = $[36];
  }
  let t19;
  if ($[37] !== t16 || $[38] !== t17) {
    t19 = {
      title: t16,
      description: t17,
      icon: t18
    };
    $[37] = t16;
    $[38] = t17;
    $[39] = t19;
  } else {
    t19 = $[39];
  }
  let t20;
  if ($[40] !== t) {
    t20 = t("creator-intro.choose.reason-6-title");
    $[40] = t;
    $[41] = t20;
  } else {
    t20 = $[41];
  }
  let t21;
  if ($[42] !== t) {
    t21 = t("creator-intro.choose.reason-6-description");
    $[42] = t;
    $[43] = t21;
  } else {
    t21 = $[43];
  }
  let t22;
  if ($[44] === Symbol.for("react.memo_cache_sentinel")) {
    t22 = <IconRobot />;
    $[44] = t22;
  } else {
    t22 = $[44];
  }
  let t23;
  if ($[45] !== t20 || $[46] !== t21) {
    t23 = {
      title: t20,
      description: t21,
      icon: t22
    };
    $[45] = t20;
    $[46] = t21;
    $[47] = t23;
  } else {
    t23 = $[47];
  }
  let t24;
  if ($[48] !== t) {
    t24 = t("creator-intro.choose.reason-7-title");
    $[48] = t;
    $[49] = t24;
  } else {
    t24 = $[49];
  }
  let t25;
  if ($[50] !== t) {
    t25 = t("creator-intro.choose.reason-7-description");
    $[50] = t;
    $[51] = t25;
  } else {
    t25 = $[51];
  }
  let t26;
  if ($[52] === Symbol.for("react.memo_cache_sentinel")) {
    t26 = <IconStars />;
    $[52] = t26;
  } else {
    t26 = $[52];
  }
  let t27;
  if ($[53] !== t24 || $[54] !== t25) {
    t27 = {
      title: t24,
      description: t25,
      icon: t26
    };
    $[53] = t24;
    $[54] = t25;
    $[55] = t27;
  } else {
    t27 = $[55];
  }
  let t28;
  if ($[56] !== t) {
    t28 = t("creator-intro.choose.reason-8-title");
    $[56] = t;
    $[57] = t28;
  } else {
    t28 = $[57];
  }
  let t29;
  if ($[58] !== t) {
    t29 = t("creator-intro.choose.reason-8-description");
    $[58] = t;
    $[59] = t29;
  } else {
    t29 = $[59];
  }
  let t30;
  if ($[60] === Symbol.for("react.memo_cache_sentinel")) {
    t30 = <IconServer />;
    $[60] = t30;
  } else {
    t30 = $[60];
  }
  let t31;
  if ($[61] !== t28 || $[62] !== t29) {
    t31 = {
      title: t28,
      description: t29,
      icon: t30
    };
    $[61] = t28;
    $[62] = t29;
    $[63] = t31;
  } else {
    t31 = $[63];
  }
  let t32;
  if ($[64] !== t) {
    t32 = t("creator-intro.choose.reason-9-title");
    $[64] = t;
    $[65] = t32;
  } else {
    t32 = $[65];
  }
  let t33;
  if ($[66] !== t) {
    t33 = t("creator-intro.choose.reason-9-description");
    $[66] = t;
    $[67] = t33;
  } else {
    t33 = $[67];
  }
  let t34;
  if ($[68] === Symbol.for("react.memo_cache_sentinel")) {
    t34 = <IconCode />;
    $[68] = t34;
  } else {
    t34 = $[68];
  }
  let t35;
  if ($[69] !== t32 || $[70] !== t33) {
    t35 = {
      title: t32,
      description: t33,
      icon: t34
    };
    $[69] = t32;
    $[70] = t33;
    $[71] = t35;
  } else {
    t35 = $[71];
  }
  let t36;
  if ($[72] !== t11 || $[73] !== t15 || $[74] !== t19 || $[75] !== t23 || $[76] !== t27 || $[77] !== t3 || $[78] !== t31 || $[79] !== t35 || $[80] !== t7) {
    t36 = [t3, t7, t11, t15, t19, t23, t27, t31, t35];
    $[72] = t11;
    $[73] = t15;
    $[74] = t19;
    $[75] = t23;
    $[76] = t27;
    $[77] = t3;
    $[78] = t31;
    $[79] = t35;
    $[80] = t7;
    $[81] = t36;
  } else {
    t36 = $[81];
  }
  const reasons = t36;
  return reasons;
};
const blurEffectClassNames = ['1.5xl:flex hidden absolute left-0 top-1/2 bg-[#903BFF] blur-[424px] w-[333px] h-[207px]', '1.5xl:flex hidden absolute right-0 top-1/2 bg-primary bg-opacity-50 blur-[424px] w-[333px] h-[207px]'];
function WhyChooseViverse() {
  const $ = _c(12);
  const reasons = useReasons();
  const t = useTranslations();
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = blurEffectClassNames.map(_temp);
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] !== t) {
    t1 = t.rich("creator-intro.choose.title", {
      highlight: _temp2
    });
    $[1] = t;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] !== t1) {
    t2 = <div className="md:header-2 header-3 inline w-full text-center"><span>{t1}</span></div>;
    $[3] = t1;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] !== reasons) {
    t3 = reasons.map(_temp3);
    $[5] = reasons;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] !== t3) {
    t4 = <div className="1.5xl:grid-cols-3 z-interactive grid gap-6 md:grid-cols-2">{t3}</div>;
    $[7] = t3;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  let t5;
  if ($[9] !== t2 || $[10] !== t4) {
    t5 = <section className="1.5xl:pb-[80px] 1.5xl:pt-[40px] 3xl:px-[120px] relative flex flex-1 flex-col justify-center gap-[48px] px-4 py-8 md:gap-[80px] md:px-[40px] md:py-20">{t0}{t2}{t4}</section>;
    $[9] = t2;
    $[10] = t4;
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  return t5;
}
function _temp3(reason, index_0, array) {
  return <motion.div key={index_0} className={cn("bg-creator-intro-hero-introduce-card 1.5xl:min-h-[208px] 1.5xl:pb-[50px] 3xl:min-h-[184px] 3xl:pb-[28px] flex flex-col gap-3 rounded-3xl p-6 pb-[54px] md:pb-[68px]", {
    "1.5xl:col-auto md:col-span-2": array.length > 2 && array.length % 2 !== 0 && index_0 === array.length - 1
  })} initial="hidden" animate="visible" exit="hidden" variants={{
    hidden: {
      opacity: 0
    },
    visible: {
      opacity: 1
    }
  }}>{reason.icon}<p className="header-4">{reason.title}</p><p className="body-2 md:body-1">{reason.description}</p></motion.div>;
}
function _temp2(chunks) {
  return <span className="text-primary">{chunks}</span>;
}
function _temp(blurEffectClassName, index) {
  return <div key={index} className={blurEffectClassName} />;
}
export default WhyChooseViverse;